import { useEffect, useMemo, useState } from 'react'
// import api from 'common/services/api'

import { TeacherInstance } from 'common/utils/types/account-types'
import { ClientTeacher } from 'common/utils/types/client-teacher'
import {
  // ClientClassroomInstance,
  // ClientStudentInstance,
  ClientTeacherInstance,
} from 'common/utils/types/account-types-client'
// import { ClientClassroom } from 'common/utils/types/client-classroom'
// import { ClientStudent } from 'common/utils/types/client-student'

import useGetCurrentUser from './useGetCurrentUser'

interface UseCurrentTeacherReturn {
  currentTeacher: ClientTeacherInstance | null
  // classrooms: Record<string, any> | null
  // students: ClientStudentInstance[] | null
  updateTeacher: (prop: keyof TeacherInstance, value: any) => void
}

export default function useCurrentTeacher(): UseCurrentTeacherReturn {
  const teacherFromHook: TeacherInstance | null = useGetCurrentUser()
  const [internalTeacherData, setInternalTeacherData] =
    useState<TeacherInstance | null>(null)

  useEffect(() => {
    setInternalTeacherData(teacherFromHook)
  }, [teacherFromHook])

  // const clientTeacher = useMemo(() => {
  //   if (!internalTeacherData) return null
  //   return new ClientTeacher(internalTeacherData)
  // }, [internalTeacherData])

  // const classroomCodes = useMemo(() => {
  //   return clientTeacher?.classroomCodes(null) ?? null
  // }, [clientTeacher])

  // const [classrooms, setClassrooms] = useState<Record<string, any> | null>(null)
  // const [students, setStudents] = useState<ClientStudentInstance[] | null>(null)
  // const [studentCodes, setStudentCodes] = useState<Record<string, string>>({})

  // useEffect(() => {
  //   if (!classroomCodes) return
  //   api({
  //     url: '/api2/refresh',
  //     method: 'POST',
  //     data: {
  //       teachers: {},
  //       classrooms: Object.keys(classroomCodes).reduce((acc, code) => {
  //         acc[code] = { version: 0, secret: classroomCodes[code] }
  //         return acc
  //       }, {}),
  //       students: {},
  //     },
  //   })
  //     .then((response) => {
  //       setClassrooms(response.data.classrooms.items)
  //     })
  //     .catch((err) => console.error(err))
  // }, [classroomCodes])

  // useEffect(() => {
  //   if (!classrooms) return

  //   const allStudentCodes = {}
  //   Object.keys(classrooms).forEach((classroomCode) => {
  //     const classroomData = classrooms[classroomCode]
  //     if (classroomData) {
  //       const c: ClientClassroomInstance = new ClientClassroom(classroomData)
  //       Object.assign(allStudentCodes, c.studentCodes())
  //     }
  //   })
  //   // Update students state once after collecting all codes
  //   setStudentCodes(allStudentCodes)
  // }, [classrooms])

  // useEffect(() => {
  //   // console.log('student codes', studentCodes)
  //   if (Object.keys(studentCodes).length === 0) return

  //   api({
  //     url: '/api2/refresh',
  //     method: 'POST',
  //     data: {
  //       teachers: {},
  //       students: Object.keys(studentCodes).reduce((acc, code) => {
  //         acc[code] = { version: 0, secret: studentCodes[code] }
  //         return acc
  //       }, {}),
  //       classrooms: {},
  //     },
  //   })
  //     .then((response) => {
  //       // console.log('students response', response)
  //       setStudents(
  //         Object.keys(response.data.students.items).map(
  //           (s) => new ClientStudent(response.data.students.items[s])
  //         )
  //       )
  //     })
  //     .catch((err) => console.error(err))
  // }, [studentCodes])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updateTeacher = (prop: keyof TeacherInstance, value: any) => {
    setInternalTeacherData((prevData) => {
      if (!prevData) return null
      return { ...prevData, [prop]: value }
    })
  }

  return {
    currentTeacher: new ClientTeacher(internalTeacherData),
    updateTeacher,
  }
}
